import { Longhand } from "../longhand.js";
import Base from "./border-top-color.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-left-color}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-left-color.js.map